"use client";

type Props = {
  value: number;
  label: string;
  size?: "desktop" | "mobile";
};

function pad(n: number): string {
  return String(n).padStart(2, "0");
}

export function PopupCountdownDigit({ value, label, size = "mobile" }: Props) {
  const boxClasses =
    size === "desktop"
      ? "flex items-center justify-center w-[68px] h-10 rounded-md border border-[#bbe3ff] bg-[#ffffff] relative"
      : "flex items-center justify-center w-[52px] rounded-md border border-[#bbe3ff] bg-[#ffffff] relative";

  const digitClasses =
    size === "desktop"
      ? "font-semibold text-[26px] leading-10 text-[#1a1c23] text-center"
      : "font-semibold text-[24px] leading-9 text-[#1a1c23] text-center";

  return (
    <div className="flex flex-col items-center gap-0.5">
      <div
        className={boxClasses}
        suppressHydrationWarning
      >
        <span className={digitClasses}>{pad(value)}</span>
      </div>
      <span className="text-sm leading-5 text-[#626e79] text-center">
        {label}
      </span>
    </div>
  );
}

type SeparatorProps = {
  size?: "desktop" | "mobile";
};

export function PopupCountdownSeparator({ size = "mobile" }: SeparatorProps) {
  return (
    <span
      className={`text-xl text-[#4b5665] self-start ${size === "desktop" ? "pt-2" : "pt-1.5"}`}
    >
      :
    </span>
  );
}
